export enum DataProviderIdEnum {
  BlackKnight = 'LPS',
  DataTrace = 'DataTrace',
  DataTraceDTAPI = 'DataTrace DTAPI'
}
